import type { Nullable } from "../types";

/**
 * This function checks if a file type is previewable.
 * It returns true if the file type is an image or a PDF, otherwise false.
 * @param fileType
 * @returns
 */
export function getIsPreviewable(fileType: Nullable<string>): boolean {
	/** Check for null or undefined */
	if (!fileType) return false;

	/** Check for image */
	if (fileType.startsWith("image/")) return true;

	/** Check for pdf */
	if (fileType === "application/pdf") return true;

	return false;
}
